export default {"src":"/_next/static/media/JointInstabilityjhk.ef70dcdc.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};